export default __webpack_public_path__ + "static/panbox-hero-b827cdbdcdb005b23cec38271ec92b89.png";